<template>
  <ukrepi-hladilnik v-if="selected == 1" />
  <ukrepi-pralni-stroj v-if="selected == 2" />
  <ukrepi-zmrzovalnik v-if="selected == 3" />
  <ukrepi-pomivalni-stroj v-if="selected == 4" />
  <ukrepi-susilni-stroj v-if="selected == 5" />
  <ukrepi-boiler v-if="selected == 6" />
  <ukrepi-computer v-if="selected == 7" />
  <ukrepi-tiskalnik v-if="selected == 8" />
  <ukrepi-televizija v-if="selected == 9" />
  <ukrepi-oven v-if="selected == 10" />
  <ukrepi-klima v-if="selected == 11" />
</template>

<script>
import UkrepiComputer from './app_ukrepi/UkrepiComputer.vue';
import UkrepiHladilnik from './app_ukrepi/UkrepiHladilnik.vue';
import UkrepiPralniStroj from './app_ukrepi/UkrepiPralniStroj.vue';
import UkrepiZmrzovalnik from './app_ukrepi/UkrepiZmrzovalnik.vue';
import UkrepiPomivalniStroj from './app_ukrepi/UkrepiPomivalniStroj.vue';
import UkrepiSusilniStroj from './app_ukrepi/UkrepiSusilniStroj.vue';
import UkrepiBoiler from './app_ukrepi/UkrepiBoiler.vue';
import UkrepiTiskalnik from './app_ukrepi/UkrepiTiskalnik.vue';
import UkrepiTelevizija from './app_ukrepi/UkrepiTelevizija.vue';
import UkrepiOven from './app_ukrepi/UkrepiOven.vue';
import UkrepiKlima from './app_ukrepi/UkrepiKlima.vue';

export default {
  props: {
    selected: Number,
  },
  components: {
    UkrepiComputer,
    UkrepiHladilnik,
    UkrepiPralniStroj,
    UkrepiZmrzovalnik,
    UkrepiPomivalniStroj,
    UkrepiSusilniStroj,
    UkrepiBoiler,
    UkrepiTiskalnik,
    UkrepiTelevizija,
    UkrepiOven,
    UkrepiKlima,
  },
  methods: {},
};
</script>

<style>
</style>